import classNames from "classnames";
import styles from "./Option.module.css";

interface OptionProps extends React.PropsWithChildren {
  active?: boolean;
  onClick(): void;
}

const Option: React.FC<OptionProps> = ({ active, onClick, children }) => {
  return (
    <div
      className={classNames(styles.container, active && styles.active)}
      onClick={onClick}
    >
      {children}
      <span className={styles.overlay} />
    </div>
  );
};

export { Option };
